import moment from "moment";
import React, { Component } from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import { compact, map, some } from "lodash";

import Assignment from "@material-ui/icons/Assignment";
import ECCard from "components/EnergyCompany/Cards/ECCard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoIcon from "@material-ui/icons/Info";
import Table from "components/Table/Table.jsx";
import Tooltip from "@material-ui/core/Tooltip";
import { numberToBRL } from "services/utils";

import lightTooltipStyle from "assets/EnergyCompany/jss/lightTooltip";

const styles = theme => ({
  ...lightTooltipStyle(theme),
});

class ConsolidatedAccounting extends Component {
  getHeaderTooltip(header) {
    const { classes } = this.props;

    return (
      <Tooltip
        classes={{ popper: classes.lightTooltipPopper, tooltip: classes.lightTooltip }}
        placement="top"
        title="Passe o mouse sobre os valores para ver informações detalhadas."
      >
        <span className={classes.tooltipContentWrapper}>
          {header} <InfoIcon />
        </span>
      </Tooltip>
    );
  }

  getTooltip(value, data) {
    const { classes } = this.props;

    return (
      <Tooltip
        classes={{ popper: classes.lightTooltipPopper, tooltip: classes.lightTooltip }}
        placement="left"
        title={
          map(data, (datum, index) => (
            <div key={index}>
              {datum.label}<b>{numberToBRL(datum.value)}</b>
            </div>
          ))
        }
      >
        <span>{numberToBRL(value)}</span>
      </Tooltip>
    );
  }

  getData = () => {
    const { consolidatedAccountingValues } = this.props;
    const deveMostrarMRE = this.deveMostrarMRE();
    let total = 0;

    const data = map(consolidatedAccountingValues, (value, key) => {
      total += value.resultadoFinal;
      return compact([
        moment(key).format("MMM Y"),
        numberToBRL(value.exposicaoMCP),
        deveMostrarMRE ? numberToBRL(value.compensacaoMRE) : undefined,
        numberToBRL(value.encargos),
        this.getTooltip(value.efeitos, [
          { label: 'Disponiblidade (ECD):', value: value.ecd },
          { label: 'Quantidade (ECQA)', value: value.ecqa },
          { label: 'Nuclear (ECCEN)', value: value.eccen },
          { label: 'Cotas (ECCGF)', value: value.eccgf },
          { label: 'Itaipu (EC_ITA)', value: value.ecita },
          { label: 'Risco Hidrológico (ERRH)', value: value.errh },
          { label: 'Descolamento PLD e PMO (E_DESC)', value: value.edesc },
        ]),
        this.getTooltip(value.ajustes, [
          { label: 'Exposições Financeiras (TAJ_EF)', value: value.ajusteExposicaoFinanceira },
          { label: 'Alívio Retroativo (TAJ_AR)', value: value.ajusteAlivioRetroativo },
          { label: 'Recontabilizações (AJU_RECON)', value: value.ajusteRecontabilizacoes },
          { label: 'MCSD Ex-Post (MCSD_XP)', value: value.ajusteMCSDExPost },
        ]),
        numberToBRL(value.excedenteER),
        numberToBRL(value.resultadoFinal),
      ]);
    });

    data.push({ total: true, colspan: this.getTableHead().length - 2, amount: numberToBRL(total) });
    return data;
  };

  getTableHead() {
    return compact([
      "Mês",
      "Exposição",
      this.deveMostrarMRE() ? "MRE" : undefined,
      "Encargos",
      this.getHeaderTooltip("Efeitos"),
      this.getHeaderTooltip("Ajustes"),
      "Exc. EER",
      "Total",
    ]);
  }

  deveMostrarMRE() {
    return some(this.props.consolidatedAccountingValues, value => value.compensacaoMRE !== 0);
  }

  render () {
    return (
      <GridContainer>
        <GridItem xs={12}>
          <ECCard
            content={
              <Table
                coloredColls={[7]}
                colorsColls={["primary"]}
                tableData={this.getData()}
                tableHead={this.getTableHead()}
                tableHeaderColor="primary"
              />
            }
            icon={<Assignment />}
            title="Contabilização"
          />
        </GridItem>
      </GridContainer>
    );
  };
};

ConsolidatedAccounting.propTypes = {
  classes: PropTypes.object.isRequired,
  consolidatedAccountingValues: PropTypes.objectOf(PropTypes.shape({
    ajusteAlivioRetroativo: PropTypes.number.isRequired,
    ajusteExposicaoFinanceira: PropTypes.number.isRequired,
    ajusteMCSDExPost: PropTypes.number.isRequired,
    ajusteRecontabilizacoes: PropTypes.number.isRequired,
    eccen: PropTypes.number.isRequired,
    eccgf: PropTypes.number.isRequired,
    ecd: PropTypes.number.isRequired,
    ecita: PropTypes.number.isRequired,
    ecqa: PropTypes.number.isRequired,
    edesc: PropTypes.number.isRequired,
    efeitos: PropTypes.number.isRequired,
    encargos: PropTypes.number.isRequired,
    errh: PropTypes.number.isRequired,
    excedenteER: PropTypes.number.isRequired,
    exposicaoMCP: PropTypes.number.isRequired,
    resultadoFinal: PropTypes.number.isRequired,
  })).isRequired,
};

export { ConsolidatedAccounting as ConsolidatedAccountingComponent };
export default withStyles(styles)(ConsolidatedAccounting);



// WEBPACK FOOTER //
// ./src/views/Dashboard/partials/ConsolidatedAccounting.jsx